import { render, staticRenderFns } from "./HistoryDataTable.vue?vue&type=template&id=592406b3&scoped=true"
import script from "./HistoryDataTable.vue?vue&type=script&lang=js"
export * from "./HistoryDataTable.vue?vue&type=script&lang=js"
import style0 from "./HistoryDataTable.vue?vue&type=style&index=0&id=592406b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592406b3",
  null
  
)

export default component.exports